import { TFunction } from "i18next";
import * as yup from "yup";
import { InferType } from "yup";

const termValidationSchema = (t: TFunction) =>
  yup.object().shape({
    revision: yup
      .string()
      .required("This field is required")
      .max(120, t("validations.max_length", { count: 120 })),
    languages: yup
      .array()
      .of(
        yup.object().shape({
          _id: yup.string().optional(),
          language: yup.string().required("Language is required"),
          title: yup
            .string()
            .required("Title is required")
            .max(200, t("validations.max_length", { count: 200 })),
          content: yup.string().required("Content is required"),
          fullContentUrl: yup.string().required("Full content URL is required"),
          fullContentLabel: yup
            .string()
            .required("Full content label is required")
            .max(120, t("validations.max_length", { count: 120 })),
        })
      )
      .min(1, "Add at least one language")
      .required(),
  });

export type TermFormData = InferType<ReturnType<typeof termValidationSchema>>;

export default termValidationSchema;
